import { BaseEntity } from '@shared/entity/base-entity';
import { Field } from '@tsim/model';

export class CategoryParamEntity extends BaseEntity {
  @Field(String, true)
  id!: string;

  @Field(String, true)
  label!: string;

  @Field(String, true)
  type!: string;

  @Field(String, false)
  def?: string;
}
